import * as React from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import RawMaterialService from "../../services/RawMaterials.service";
import LanguagesService from "../../services/Languages.service";
import { useTranslation } from "react-i18next";
import { avaiableLangList } from '../../i18nextConf'
import { GridCustomAltIdCommandCell } from "../../components/GridCustomAltIdCommandCell";
import { GridCustomLoadingCell } from "../../components/GridCustomLoadingCell";
import { PanelCustomLoader } from "../../components/PanelCustomLoader";


export default function RawMaterialAlternativeIdentifiers(props) {

    const { t } = useTranslation();
    const editField = "inEdit";
    const isAdmin = props.isAdmin;

    const [languages, setLanguages] = React.useState([]);
    const [selectedLenguage, setSelectedLenguage] = React.useState({ name: "Loading...", languageId: "" });
    const [rawMaterialsAlternativeIDs, setRawMaterialsAlternativeIDs] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {

        LanguagesService.getLanguages()
            .then(response => response.data.contract)
            .then(json => {
                setLanguages(json);
                var selected = localStorage.getItem("i18nextLng") || "en";
                var selectedLangDetails = avaiableLangList.find(lang => lang.short === selected);
                var defaultLang = json.find(lang => lang.languageId === selectedLangDetails.id);
                setSelectedLenguage(defaultLang);
            });

    }, []);


    React.useEffect(() => {

        if (selectedLenguage.languageId !== "")
            RawMaterialService.getrawMaterialsAlternativeIdentifiers(props.rawMaterialId, selectedLenguage.languageId)
                .then(response => response.data)
                .then(json => {
                    setRawMaterialsAlternativeIDs(json.contract);
                    setLoading(false);
                }).catch(json => {
                    setRawMaterialsAlternativeIDs([]);
                    setLoading(false);
                });

    }, [props.rawMaterialId, selectedLenguage]);

    const remove = dataItem => {

        RawMaterialService.deleteRawMaterialAlternativeIdentifier({
            "rawMaterialAlternativeIdentifierId": dataItem.rawMaterialAlternativeIdentifierId,
            "rawMaterialId": props.rawMaterialId
        }).then(response => {

            RawMaterialService.getrawMaterialsAlternativeIdentifiers(props.rawMaterialId, selectedLenguage.languageId)
                .then(response => response.data.contract)
                .then(json => {
                    setRawMaterialsAlternativeIDs(json);
                    setLoading(false);
                }).catch(json => {
                    setRawMaterialsAlternativeIDs([]);
                    setLoading(false);
                });;
        });
    };

    const add = dataItem => {

        dataItem.inEdit = true;

        RawMaterialService.saverawMaterialAlternativeIdentifier({
            "rawMaterialAlternativeIdentifierId": Math.floor(Math.random() * 1000) + 1,
            "rawMaterialId": props.rawMaterialId,
            "languageId": selectedLenguage.languageId,
            "alternativeName": dataItem.alternativeName
        })
            .then(response => {

                var data = rawMaterialsAlternativeIDs.map(item => (item.rawMaterialAlternativeIdentifierId === dataItem.rawMaterialAlternativeIdentifierId) ?
                    { ...item, rawMaterialAlternativeIdentifierId: response.data.contract.rawMaterialAlternativeIdentifierId, inEdit: false, isNew: false } : item);

                setRawMaterialsAlternativeIDs(data);
            });

    };

    const update = dataItem => {

        dataItem.inEdit = false;

        RawMaterialService.updateRawMaterialAlternativeIdentifier({
            "rawMaterialAlternativeIdentifierId": dataItem.rawMaterialAlternativeIdentifierId,
            "rawMaterialId": props.rawMaterialId,
            "languageId": dataItem.languageId,
            "alternativeName": dataItem.alternativeName
        })
            .then(response => {
                RawMaterialService.getrawMaterialsAlternativeIdentifiers(props.rawMaterialId, selectedLenguage.languageId)
                    .then(response => response.data)
                    .then(json => {
                        setRawMaterialsAlternativeIDs(json.contract);
                        setLoading(false);
                    });
            })

    };

    const discard = dataItem => {

        setRawMaterialsAlternativeIDs(rawMaterialsAlternativeIDs.filter(item => item.rawMaterialAlternativeIdentifierId !== dataItem.rawMaterialAlternativeIdentifierId));

    };

    const cancel = dataItem => {

        const itemEdit = rawMaterialsAlternativeIDs.find(item => (item.rawMaterialAlternativeIdentifierId === dataItem.rawMaterialAlternativeIdentifierId));

        setRawMaterialsAlternativeIDs(rawMaterialsAlternativeIDs.map(itemMap =>
            itemEdit.rawMaterialAlternativeIdentifierId === itemMap.rawMaterialAlternativeIdentifierId ?
                { ...itemMap, inEdit: false } : itemMap));

    };

    const enterEdit = dataItem => {

        setRawMaterialsAlternativeIDs(rawMaterialsAlternativeIDs.map(item => (item.rawMaterialAlternativeIdentifierId === dataItem.rawMaterialAlternativeIdentifierId) ? { ...item, inEdit: true, isNew: false } : item));

    };

    const itemChange = event => {

        const data = rawMaterialsAlternativeIDs.map(item => item.rawMaterialAlternativeIdentifierId === event.dataItem.rawMaterialAlternativeIdentifierId ? { ...item, [event.field]: event.value } : item);

        setRawMaterialsAlternativeIDs(data);

    };

    const CommandCell = props => (
        <GridCustomAltIdCommandCell
            {...props}
            edit={enterEdit}
            remove={remove}
            add={add}
            discard={discard}
            update={update}
            cancel={cancel}
            editField={editField}
        />
    );

    const addNew = () => {

        const newDataItem = { isNew: true, inEdit: true, alternativeName: "", rawMaterialAlternativeIdentifierId: Math.floor(Math.random() * 1000) + 1 };

        const data = [newDataItem, ...rawMaterialsAlternativeIDs];

        setRawMaterialsAlternativeIDs(data);
    };

    return (
        <div>
            {loading && PanelCustomLoader}

            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    {isAdmin ? (<button
                        title={t("RawMaterials_AlternativeIdentifiers_Button_Tooltip_New")}
                        className="k-button k-primary"
                        onClick={addNew} >
                        &nbsp;<span className="k-icon k-i-plus-circle" />&nbsp; {t("Global_Button_Text_New")} &nbsp;
                    </button>) : (<span />)}

                    <DropDownList
                        label={t("Global_Label_Text_Language")}
                        name="language"
                        textField="name"
                        value={selectedLenguage}
                        loading={loading}
                        dataItemKey="languageId"
                        style={{ width: '200px' }}
                        onChange={e => setSelectedLenguage(e.value)}
                        data={languages}
                    />
                </div>
                <div>

                    <Grid
                        itemChange={itemChange}
                        data={rawMaterialsAlternativeIDs}
                        editField={editField}
                        total={rawMaterialsAlternativeIDs.length}
                        pageable={false}
                        scrollable={'none'}
                        cellRender={GridCustomLoadingCell}
                        onItemChange={itemChange}
                    >

                        {isAdmin ? (<Column cell={CommandCell} width="120px" />) : (<span />)}
                        <Column field="alternativeName" title={t("RawMaterials_AlternativeIdentifiers_Label")} />

                    </Grid>
                </div>
            </div>
        </div>
    );

}
